import { AbstractImageLoader, AbstractImageLoaderOptions } from "./AbstractImageLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export interface CanvasLoaderOptions extends AbstractImageLoaderOptions {
    scale?: number | ((width: number, height: number) => number);
}

export class CanvasLoader extends AbstractImageLoader<HTMLCanvasElement, CanvasLoaderOptions>{
    protected async convert(img: HTMLImageElement): Promise<HTMLCanvasElement> {
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;

        var scale = 1;
        if (typeof this._options.scale === "function") {
            scale = this._options.scale(w, h);

        } else {
            scale = this._options.scale;
        }
        w *= scale;
        h *= scale;

        var can = document.createElement("canvas");
        can.width = w;
        can.height = h;
        var ctx = can.getContext("2d");
        ctx.drawImage(img, 0, 0, w, h);
        return can;
    }

    protected defaultOptions(): CanvasLoaderOptions {
        return {
            scale: 1
        };
    }
}

registerLoader("canvas", CanvasLoader);